module.exports = __webpack_public_path__ + "img/cxample_06.e5512be5.png";